import React, { useEffect, Fragment, useState } from "react";

import Backgrounds from "../../_partials/Backgrounds/Index";
import TemplateBlock from "../../_partials/TemplateBlock/Index";
import prepareVideoBg from "../../../../shared/functions/prepareVideoBg";
import animationScript, { animationCleanUp } from "./animation";

import assets from "./assets";

import "./style/style.scss";
import "./style/animation.scss";
import getContentById from "../../../../shared/utils/getContentById";
import ImageOrVideo from "../../../../shared/components/ImageOrVideo/Index";
import parseMediaUrl from "../../../../shared/functions/parseMediaUrl";
import TeamLogo from "../../_partials/TeamLogo";
import { MatchScoreWidget } from "../../_partials/MatchScoreWidget/MatchScoreWidgetForBild";
import Stats from "./stats";
import ProgressBar from "../../../../shared/components/ProgressBar";
import _ from "lodash";
import { getGlobalMatchdays } from "../../../../../services/backend/api.service";
import { getDynamicLogoPath } from "../../../../shared/utils/functions";
import Image from "../../../../shared/components/Image";
import sportWorldShadow from "../../../assets/wc/images/sportworld_image_shadow.png";
import { useTranslation } from "react-i18next";
import PlayerFact from "./PlayerFact";
import BildTeamLogo from "../../../../shared/components/Image/BildTeamLogo";

const getMainBackground = () => {
  return assets.background_1920;
};

const getCountryFromId = (id, teams) => {
  const team = _.find(teams, { id: id });
  return team?.name;
};

const getTeamLogoById = (id, teams, competitionId, feedType = "opta") => {
  const logoUrl = _.get(_.find(teams, { id: id }), "logo.url");
  const fallback = "/images/preview/worldcup/ball.png";
  if (logoUrl) {
    return <Image className="team-logo" src={`${config.apiUrl}${logoUrl}`} />;
  }

  const team = _.find(teams, { id: id });
  const countryCode = _.get(team, "name");
  const countryCodeShortcut = _.get(team, "shortcut");
  const opta3Alpha = _.get(team, "code");

  const src = getDynamicLogoPath({
    team: {
      name: countryCode,
      shortName: countryCodeShortcut,
      code: opta3Alpha,
      id,
    },
    competitionId,
    feedType,
  });
  return <Image className="team-logo" src={src} />;
};

const Index = ({ animation, data, mode, format, _searchParams, ...props }) => {
  const templateName = data?.template_name ?? "";
  const id = `${templateName}_${data?.uuid}`;
  const { isTimeline } = props;
  const backgroundImage = getMainBackground();
  const { t } = useTranslation();

  const prepareAnimation = () => {
    prepareVideoBg({ id });
  };

  useEffect(() => {
    let animationReturn = null;
    if (mode === "animation" || mode === "video") {
      if (animation) {
        prepareAnimation();
        animationReturn = animationScript({
          id,
          data,
          format,
          apiSetup: props?.apiSetup,
          templateName: data?.template_name,
        });
      }
    }

    if (mode === "screenshot") {
      const videoBg = $(`#${id} video.custom-background`).get(0);
      if (videoBg) {
        videoBg.addEventListener(
          "loadedmetadata",
          function () {
            this.currentTime = 3;
            this.pause();
          },
          false,
        );
      }
    }

    return function cleanUp() {
      if (animationReturn) {
        animationCleanUp(animationReturn);
      }
    };
  }, [animation, mode]);

  const { options, fields, dynamic } = data.data || {};

  const { matchDetails = {}, teamSide } = data?.data?.dynamic || {};

  const matchStatus = matchDetails?.matchStatus;
  const scores = matchDetails?.scores;

  const teamId = data?.event[teamSide]?.id;

  const headline = fields.find(({ id }) => id === "headline");
  const stats = fields.find(({ id }) => id === "stats")?.value || [];

  const type = fields.find(({ id }) => id === "type")?.value || "player-facts";

  const facts = fields.filter(({ type }) => type === "html");

  const selectedSide = getContentById("selectedSide", fields);
  const imageSide = getContentById("imageSide", fields) || "left";
  const isLeft = imageSide === "left";
  const isRight = imageSide === "right";
  const isTop = imageSide === "top";
  const isBottom = imageSide === "bottom";
  const selectedCountryId = getContentById("facts_country", fields);
  const selectedDiscipline = getContentById("facts_discipline", fields);
  const matchInfo = _.get(dynamic, "matchInfo");
  const homeTeam = matchInfo?.home;
  const awayTeam = matchInfo?.away;

  const customBackground = getContentById("background", fields, "self");
  return (
    <div
      id={id}
      className={`T_${templateName} ${animation ? "animation" : ""} image-side-${imageSide}`}
    >
      <TemplateBlock class={`${isTimeline ? "" : "template-bild"}`}>
        {
          !isTimeline && <div className="main-header-content">
            <div className="main-header">
              {t("Top Facts", { keyPrefix: "templates" })}
            </div>
            <MatchScoreWidget
              homeTeam={homeTeam}
              awayTeam={awayTeam}
              matchInfo={matchInfo}
            />
          </div>
        }
        <div className={`wc-content wc-content-v2`}>
          <ProgressBar height={"8px"} />
          <div className="main-content-side">

            {isLeft && <div className={"left-block-side"}>
              <img
                className={"custom-background"}
                src={parseMediaUrl(_.get(customBackground, "value.url"))}
              />
              <div className="left-block-shadow"></div>
            </div>}
            <div className={"center-block-side"}>
              <div
                className={isLeft ? "center-block-left" : "center-block-right"}
              >
                <div className={"box"}>
                  <div className="header-wrap">
                    {/* team logo */}
                    <div className="main-logo">
                      <BildTeamLogo className="team-logo-single" id={selectedSide === "home" ? homeTeam?.id : awayTeam?.id} />
                    </div>
                    <div className="header-title">
                      {headline?.value}
                    </div>
                  </div>
                  <div
                    className={"facts-content"}
                  >
                    {facts.map((fact) => {
                      return fact?.value ? (
                        <div key={fact.id} >
                          <PlayerFact fact={fact} />
                        </div>
                      ) : null;
                    })}
                  </div>

                </div>
              </div>
            </div>
            {isRight && <div className={"right-block-side"}>
              <img
                className={"custom-background"}
                src={parseMediaUrl(_.get(customBackground, "value.url"))}
              />
              <div className="right-block-shadow"></div>
            </div>}
          </div>
        </div>
      </TemplateBlock>
    </div>
  );
};

export default Index;
